import type {AppConfig} from '../types'
import {__NAME__} from './app-config-name'

// SSR-safe: проверяем наличие window перед обращением
export const config: AppConfig =
  typeof window !== 'undefined' ? (window as unknown as Record<string, AppConfig>)[__NAME__] : ({} as AppConfig)

/**
 * Определяет, что страница открыта через редирект с Яндекс.Маркета
 * (старая интеграция, май 2024).
 *
 * Определяется server-side по:
 * - HTTP referer header (паттерн market.yandex.ru)
 * - User-Agent header (паттерн Beru/ - старое название Маркета)
 *
 * Используется для:
 * - Скрытия промо-баннеров при переходе с маркета
 * - Отключения кликабельности логотипа
 * - Применения специальных стилей
 */
export const isMarketIntegration = config.sourceService === 'market'

export const isAuthMode = config.apiMode === 'auth'

export const direction = config.lang === 'he' ? 'rtl' : 'ltr'

export type {RouteConfigs} from './experiments'
export {RouteExperiments} from './experiments'
